import { Middleware, Dispatch, AnyAction } from 'redux';
import { shouldLogAction, getActionLogType } from 'support/actionHelper';
import logger from 'common/support/Log';

const loggerMiddleware: Middleware = () => (next: Dispatch) => (action: AnyAction) => {
  // Example of a logging middleware.  Can be configured
  // to hit an external logging service if need be.

  if (!shouldLogAction(action) || action.type === 'LOG') {
    return next(action);
  }

  const log = getActionLogType(action) === 'ERROR' ? logger.error : logger.info;

  log(`Action to be dispatched: ${action.type}`);
  const returnValue = next(action);
  log(`Action has been dispatched and state has been updated: ${action.type}`);

  return returnValue;
};

export default loggerMiddleware;
